import { users } from "../fake-db/users";
import { MessageType } from "../types/messageType";

export const chatContacts = (messages: MessageType[]) => {
  const data = users.filter((u) => {
    return messages.find((m) => {
      return m.receiverId === `${u.id}`;
    });
  });
  return data;
};
